import axios from './axios';
import SETTINGS from '../settings'
export default {
    getCompanyFiles(params, cb) {
        axios.get(`${SETTINGS.API_BASE_PATH}/filecompany`, {params: params}).then(response => {
            cb(response.data)
        }).catch(e => {
            console.log(e)
        })
    },
    getDefaultImages(params, cb) {
        axios.get(`${SETTINGS.API_BASE_PATH}/loadimages`, {params: params}).then(response => {
            cb(response.data)
        }).catch(e => {
            console.log(e)
        })
    },
    getCategoriesImages(cb) {
        axios.get(`${SETTINGS.API_BASE_PATH}/settingglobal?SettingType_code_idSettingType_idType=DEFAULTIMAGECATEGORIES`).then(response => {
            cb(response.data)
        }).catch(e => {
            console.log(e)
        })
    },
    addFile(file, cb) {
        axios.post(`${SETTINGS.API_BASE_PATH}/uploadfile`, file).then(response => {
            cb(response.data)
        }).catch(e => {
            cb(e)
        })
    }
}